import { IState } from 'core/types';

export const getAreasCropped = ({ area }: IState) => area.areasCropped;
export const getAllAreas = ({ area }: IState) => area.allAreas;
export const getArea = ({ area: { area } }: IState) => area;
export const getIsAreaLoading = ({ area: { isAreaLoading } }: IState) => isAreaLoading;
export const getAreaCalendarEvents = ({ area: { calendarEvents } }: IState) => calendarEvents;
